<template>
  <div class="is-margin">
    <div v-if="notes.length === 0" class="is-marginless">
      <div class="level-left">
        <span class=""><b>Il n'y a aucune note de suivi</b></span>
      </div>
    </div>
    <template v-else v-for="(note, idx) in notes">
      <div :key="idx" class="vadDiscussion">
        <div class="vadDiscussion--bulle is-size-6" :class="{ 'is-bis' : note.user !== currentUserPk}">
          <div class="content" v-html='note.message'></div>
        </div>
        <div class="columns is-gapless is-size-7 is-multiline">
          <div class="column is-12 is-7-fullhd is-margin-top-xxsmall">
            <div><b>Date :</b> {{note.created_on|dateAdv}}</div>
            <div><b>Auteur :</b>
              <span v-if="note.user === currentUserPk">Vous</span>
              <span v-else>{{note.user_last_name}} {{note.user_first_name}}</span>
              <span>({{note.user_profil | profilTypeLabel}})</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { DefaultValues } from '@/mixins'

  export default {
    name: 'NotesAdv',
    mixins: [DefaultValues],
    data () {
      return {
        moment
      }
    },
    props: {
      source: Array
    },
    filters: {
      dateAdv: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' - ' + hour + ':' + minute
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      notes () {
        return this.source
      }
    },
    methods: {
      submit () {
        this.$emit('submit', this.notes)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/NotesAdv.vue